module.exports = __webpack_public_path__ + "img/fibonacci.7f2e9760.png";